import { useMutation } from '@tanstack/react-query';
import { apiClient } from '@/api/client';
import { API_EVALUATION_REPORTS } from '@/api/endpoints';
import type { StudyYearPeriod } from '@/types/overview';
import { unwrapAxiosResponse } from '@/utils/axios';
import { toApiDate } from '@/utils/date';
import { createPdfObjectUrl } from '@/utils/file';

export const useEvaluationReport = () =>
  useMutation({
    mutationFn: (period: StudyYearPeriod) =>
      apiClient
        .get<Blob>(API_EVALUATION_REPORTS, {
          params: { from: toApiDate(period.from), to: toApiDate(period.to) },
          responseType: 'blob',
        })
        .then(unwrapAxiosResponse)
        .then(createPdfObjectUrl),
  });
